module.exports = __webpack_public_path__ + "static/media/Jian Pei.5ff339f9.jpg";